import { render, staticRenderFns } from "./ModalA.vue?vue&type=template&id=068d9044&lang=pug&"
import script from "./ModalA.vue?vue&type=script&lang=js&"
export * from "./ModalA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports